<template>
  <div class="field-item">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <!-- PC 端：Element UI -->
      <template v-if="!isMobile">
        <el-time-picker
          v-if="pickerType === 'time'"
          v-model="inner"
          :format="displayFormat"
          :value-format="valueFormat"
          :placeholder="field.prompt || '請選擇'"
          style="width:100%"
          clearable
          @change="onDateChange"
        />
        <el-date-picker
          v-else
          v-model="inner"
          :type="pickerType"
          :format="displayFormat"
          :value-format="valueFormat"
          :placeholder="field.prompt || '請選擇'"
          style="width:100%"
          clearable
          @change="onDateChange"
        />
      </template>
      <!-- 手機端：原生輸入 -->
      <div v-else class="native-date-wrapper">
        <input
          :type="nativeInputType"
          class="native-date-input"
          :class="{ 'has-value': !!nativeValue }"
          :value="nativeValue"
          @input="onNativeInput"
        />
        <span v-if="!nativeValue" class="native-date-placeholder">{{ field.prompt || '請選擇' }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FieldDatetime',
  props: { field: Object, value: { default: '' } },
  data () { return { inner: this.value || '' } },
  watch: { value (v) { this.inner = v || '' } },
  computed: {
    cfgData () { return this.field.data || {} },
    datef () { return this.cfgData.datef || '' },
    timef () { return this.cfgData.timef || '' },
    // 是否手機端
    isMobile () {
      return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent)
    },
    // el-date-picker / 原生 input type
    pickerType () {
      if (this.timef && !this.datef) return 'time'
      if (this.timef) return 'datetime'
      if (this.datef === 'yyyy-MM') return 'month'
      return 'date'
    },
    // 原生 input 的 type 屬性
    nativeInputType () {
      const map = { date: 'date', month: 'month', datetime: 'datetime-local', time: 'time' }
      return map[this.pickerType] || 'date'
    },
    // 顯示格式（el-date-picker 用 HH:mm:ss 大寫）
    displayFormat () {
      if (this.timef && !this.datef) return this.timef
      if (this.timef) return `${this.datef} HH:mm`
      if (this.datef === 'yyyy-MM') return 'yyyy-MM'
      return this.datef || 'yyyy-MM-dd'
    },
    // 提交格式（value-format）
    valueFormat () { return this.displayFormat },
    // 原生輸入框的值（API 格式 → 原生格式）
    nativeValue () { return this.apiToNative(this.inner) }
  },
  methods: {
    onDateChange (v) { this.$emit('input', v || '') },
    onNativeInput (e) {
      const val = e.target.value
      this.inner = this.nativeToApi(val)
      this.$emit('input', this.inner || '')
    },
    // API 格式 → 原生格式
    apiToNative (val) {
      if (!val) return ''
      if (this.pickerType === 'datetime') return String(val).replace(' ', 'T')
      return val
    },
    // 原生格式 → API 格式
    nativeToApi (val) {
      if (!val) return ''
      if (this.pickerType === 'datetime') return val.replace('T', ' ')
      return val
    }
  }
}
</script>
